import {
   formatClienteNombreCompleto,
   urlAbm,
   urlBsa,
   urlEmpresa,
   urlFiles,
   urlFlujoArt,
   urlMail,
   urlMailBackend,
} from '@/helpers';
import { mensajeConfirmacion } from '@/composables/mensajesSwal';
import { httpInstance } from '@/clients/http.request';
import { showError } from '@/composables/useToast';

export const getCompaniesBsa = async (
   { commit },
   { id_seccion, id_compania_anterior },
) => {
   try {
      const { data } = await httpInstance.get(`${urlBsa}/companies`, {
         id_seccion,
         id_compania_anterior,
      });
      commit('setCompaniesBsa', data);
   } catch (error) {
      throw error;
   }
};

export const getSuscriptoresBsa = async ({ rootState, commit }) => {
   try {
      const { data } = await httpInstance.get(`${urlBsa}/suscriptores`);
      commit('setSuscriptores', data);
   } catch (error) {
      throw error;
   }
};

export const createSeguimiento = async ({ state, rootState, commit }) => {
   try {
      if (
         !state.fecha_resolucion ||
         !state.suscriptor.value ||
         !rootState.poliza.poliza.id_seccion ||
         !rootState.poliza.poliza.id_poliza ||
         !rootState.auth.usuario.id_usuario ||
         state.companiasAsignadas.length === 0
      ) {
         throw new Error('Faltan datos');
      }
      const { data } = await httpInstance.post(`${urlBsa}/createSeguimiento`, {
         id_poliza: rootState.poliza.poliza.id_poliza,
         id_seccion: rootState.poliza.poliza.id_seccion,
         id_usuario: state.suscriptor.value,
         fecha_resolucion: state.fecha_resolucion
            .split('/')
            .reverse()
            .join('/'),
         comentario: state.comentario,
         companias: state.companiasAsignadas,
         usuarioCreador: rootState.auth.usuario.id_usuario,
      });
      commit('poliza/setPolicies', data.updatedPolicies, { root: true });
      mensajeConfirmacion(
         'Seguimiento asignado con exito',
         `El caso fue asignado a <b>${state.suscriptor.label}</b>.<br>
         Fecha de resolución: ${state.fecha_resolucion}`,
      );
   } catch (error) {
      throw error;
   }
};

export const sendSeguimientoMail = async ({ state, rootState }) => {
   try {
      await httpInstance.post(`${urlMailBackend}/sendSeguimientoMail`, {
         id_poliza: rootState.poliza.poliza.id_poliza,
      });
   } catch (error) {
      throw error;
   }
};

export const sendEmailClient = async ({ rootState }, { formData }) => {
   let response;
   try {
      response = await httpInstance.post(
         `${urlMailBackend}/sendMailClient`,
         formData,
         true,
      );
      mensajeConfirmacion(
         'Envio de email exitoso',
         `Se envio el correo a <b>${formData.get('to')}</b>`,
      );
   } catch (error) {
      throw error;
   }

   return response.data;
};

export const sendEmailCompanias = async ({ rootState }, { formData }) => {
   let response;
   try {
      response = await httpInstance.post(
         `${urlMailBackend}/sendMailCompanias`,
         formData,
         true,
      );
   } catch (error) {
      throw error;
   }
   return response.data;
};

export const deleteFile = async (_, data) => {
   try {
      await httpInstance.delete(
         `${urlFiles}/delete?id_file=${data.id_file}&esCotizacion=${data.esCotizacion ? 1 : 0
         }`,
      );
   } catch (error) {
      throw error;
   }
};

export const sendEmailCotizado = async (
   { state, rootState },
   { selectedCaso, comentario, id_seguimiento },
) => {
   try {
      await httpInstance.post(`${urlMailBackend}/sendEmailCotizado`, {
         id_poliza: selectedCaso.id_poliza,
         nombreCliente:
            selectedCaso.cliente ??
            formatClienteNombreCompleto(selectedCaso, 'Sin nombre'),
         id_seccion: selectedCaso.id_seccion,
         emailAdminSeguimiento: selectedCaso.emailAdminSeguimiento,
         comentario: comentario || undefined,
         id_seguimiento,
      });
   } catch (error) {
      throw error;
   }
};

export const getSeguimientoVigente = async ({ commit }, id_poliza) => {
   try {
      const seguimiento = await httpInstance.get(
         `${urlBsa}/getSeguimientoVigente`,
         { id_poliza },
      );
      commit('bsa/setCasoAsignado', seguimiento.data, { root: true });
   } catch (error) {
      throw error;
   }
};
export const getProspectSeguimiento = async ({ commit }, id_poliza) => {
   try {
      const seguimiento = await httpInstance.get(
         `${urlBsa}/getProspectSeguimiento`,
         { id_poliza },
      );
      commit('bsa/setCasoAsignado', seguimiento.data, { root: true });
   } catch (error) {
      throw error;
   }
};

export const getAbms = async ({ commit }) => {
   try {
      const abms = await httpInstance.get(`${urlAbm}/getAbms`);
      commit('bsa/setAbms', abms.data, { root: true });
   } catch (error) {
      throw error;
   }
};

export const getDataBaseTable = async ({ commit }, payload) => {
   try {
      const { data } = await httpInstance.post(`${urlAbm}/getDatabaseTable`, {
         tabla: payload.value,
         keys: payload.keys,
      });
      commit('bsa/setOptionsAbm', data.selectData, { root: true });
      return data.dataAbm;
   } catch (error) {
      throw error;
   }
};
export const createRecord = async ({ commit }, payload) => {
   try {
      const { data } = await httpInstance.post(
         `${urlAbm}/${payload.tabla}`,
         payload.data,
      );
      return data;
   } catch (error) {
      throw error;
   }
};
export const updateRecord = async ({ commit }, payload) => {
   try {
      const { data } = await httpInstance.put(
         `${urlAbm}/${payload.tabla}`,
         payload.data,
      );
      return data;
   } catch (error) {
      throw error;
   }
};
export const deleteRecord = async ({ commit }, payload) => {
   try {
      let data;
      if (Object.keys(payload).length === 3) {
         data = await httpInstance.delete(
            `${urlAbm}/${payload.tabla}/${payload.id}/${payload.id_empresa}`,
         );
      } else {
         data = await httpInstance.delete(
            `${urlAbm}/${payload.tabla}/${payload.id}`,
         );
      }
      return data;
   } catch (error) {
      throw error;
   }
};

export const setCompaniaSeguimiento = async ({ rootState, commit }, data) => {
   try {
      const companies = await httpInstance.post(
         `${urlFlujoArt}/companiaSeguimiento`,
         { companias: data.companias, id_seguimiento: data.id_seguimiento },
      );
      const comentarios = await httpInstance.post(
         `${urlBsa}/createComentario`,
         {
            comentario: data.comentario,
            id_seguimiento: data.id_seguimiento,
            id_usuario: rootState.auth.usuario.id_usuario,
         },
      );

      commit('setCompaniaSeguimientoBsa', companies.data);
      commit('setComentarioSeguimientoBsa', comentarios.data);
   } catch (error) {
      throw error;
   }
};

const sanitizeHTML = (html) => {
   const parser = new DOMParser();
   const doc = parser.parseFromString(html, 'text/html');

   doc.querySelectorAll('script').forEach((script) => script.remove());
   doc.querySelectorAll('*').forEach((el) => {
      for (const attr of el.attributes) {
         if (attr.name.startsWith('on')) {
            el.removeAttribute(attr.name);
         }
      }
   });
   return doc.body.innerHTML;
};

export const uploadProducts = async (_, formData) => {
   try {
      const { data } = await httpInstance.post(
         `${urlFiles}/uploadProducts`,
         formData,
         true,
      );
      return data;
   } catch (error) {
      throw error;
   }
};

export const getEmpresa = async (
   { rootState, dispatch },
   { id_empresa, esPng },
) => {
   try {
      const response = await httpInstance.get(`${urlEmpresa}/${id_empresa}`);
      const { data } = await dispatch('main/getCompanyIcon', { id_empresa, esPng }, { root: true });
      return { empresa: response.data, iconEmpresa: { data } };
   } catch (error) {
      throw error;
   }
};

export const getCompany = async ({ rootState }, id_compania) => {
   try {
      const response = await httpInstance.get(
         `${urlBsa}/company/${id_compania}`,
      );
      return response.data;
   } catch (error) {
      throw error;
   }
};

export const getCompanyWithCodes = async (_, { id_compania, id_empresa, id_seccion }) => {
   try {
      const response = await httpInstance.get(
         `${urlBsa}/company/${id_compania}/${id_empresa}/${id_seccion}`,
      );
      return response.data;
   } catch (error) {
      throw error;
   }
};

export const getEmpresasByCompania = async ({ rootState }, id_compania) => {
   try {
      const response = await httpInstance.get(
         `${urlBsa}/company/${id_compania}/empresas`,
      );
      return response.data;
   } catch (error) {
      throw error;
   }
};

export const getVendedores = async (_, id_empresa) => {
   try {
      const response = await httpInstance.get(`${urlAbm}/vendedores`, {
         id_empresa,
      });
      return response.data;
   } catch (error) {
      throw error;
   }
};
export const getEmpresas = async (_) => {
   try {
      const response = await httpInstance.get(`${urlEmpresa}/allActives`);
      return response.data;
   } catch (error) {
      throw error;
   }
};

export const createUsuario = async (_, usuarioData) => {
   try {
      const dataToSend = usuarioData.data || usuarioData;
      const { data } = await httpInstance.post(
         `${urlAbm}/usuario`,
         { data: dataToSend },
      );
      return data;
   } catch (error) {
      throw error;
   }
};

export const updateUsuario = async (_, usuarioData) => {
   try {
      const dataToSend = usuarioData.data || usuarioData;
      const { data } = await httpInstance.put(`${urlAbm}/usuario`, {
         data: dataToSend,
      });
      return data;
   } catch (error) {
      throw error;
   }
};

export const deleteUsuario = async (_, { id }) => {
   try {
      const { data } = await httpInstance.delete(
         `${urlAbm}/usuario/${id}`,
      );
      return data;
   } catch (error) {
      throw error;
   }
};

export const rehabilitarUsuario = async (_, { id }) => {
   try {
      const { data } = await httpInstance.put(
         `${urlAbm}/usuario/${id}/rehabilitar`,
      );
      return data;
   } catch (error) {
      throw error;
   }
};

export const getUsuarios = async (_, params = {}) => {
   try {
      const query = {};
      if (params.q) {
         query.q = params.q;
      }
      if (params.id_empresa != null) {
         query.id_empresa = params.id_empresa;
      }
      if (params.id_sucursal_interno != null) {
         query.id_sucursal_interno = params.id_sucursal_interno;
      }
      const { data } = await httpInstance.get(`${urlAbm}/usuarios`, query);
      return data;
   } catch (error) {
      throw error;
   }
};

export const getSucursales = async (_, id_empresa) => {
   try {
      const { data } = await httpInstance.get(
         `${urlAbm}/sucursal/allActives/${id_empresa}`,
      );
      return data;
   } catch (error) {
      throw error;
   }
};

export const getNivelesUsuario = async (_, id_empresa) => {
   try {
      const { data } = await httpInstance.get(`${urlAbm}/niveles-usuario`, {
         id_empresa,
      });
      return data;
   } catch (error) {
      throw error;
   }
};

export const getSucursalesDisponiblesRegion = async (_, id_empresa) => {
   try {
      const { data } = await httpInstance.get(
         `${urlAbm}/region/sucursales-disponibles`,
         { id_empresa },
      );
      return data;
   } catch (error) {
      throw error;
   }
};

export const getRegiones = async (_, { id_empresa }) => {
   try {
      const { data } = await httpInstance.get(`${urlAbm}/region`, {
         id_empresa,
      });
      return data;
   } catch (error) {
      throw error;
   }
};

export const getRegionesActivas = async (_, { id_empresa, id_usuario }) => {
   try {
      const params = { id_empresa };
      if (id_usuario) {
         params.id_usuario = id_usuario;
      }
      const { data } = await httpInstance.get(`${urlAbm}/region/activas`, params);
      return data;
   } catch (error) {
      throw error;
   }
};

export const getRegionByUsuario = async (_, id_usuario) => {
   try {
      const { data } = await httpInstance.get(
         `${urlAbm}/region/usuario/${id_usuario}`,
      );
      return data;
   } catch (error) {
      throw error;
   }
};

export const createRegion = async (_, payload) => {
   try {
      const { data } = await httpInstance.post(`${urlAbm}/region`, payload);
      return data;
   } catch (error) {
      throw error;
   }
};

export const updateRegion = async (_, { id_region, ...payload }) => {
   try {
      const { data } = await httpInstance.put(
         `${urlAbm}/region/${id_region}`,
         payload,
      );
      return data;
   } catch (error) {
      throw error;
   }
};

export const getUsuarioAuditHistory = async (_, id_usuario) => {
   try {
      const { data } = await httpInstance.get(
         `${urlAbm}/usuario/${id_usuario}/auditoria`,
      );
      return data;
   } catch (error) {
      throw error;
   }
};

export const getCompaniaAuditHistory = async (_, id_compania) => {
   try {
      const { data } = await httpInstance.get(
         `${urlAbm}/compania/${id_compania}/auditoria`,
      );
      return data;
   } catch (error) {
      throw error;
   }
};

export const getAllTerminos = async () => {
   try {
      const { data } = await httpInstance.get(`${urlBsa}/getAllTerminos`);
      return data;
   } catch (error) {
      throw error;
   }
};

export const downloadTermino = async (
   _,
   { id_compania, id_seccion, id_empresa },
) => {
   try {
      const { data } = await httpInstance.get(`${urlFiles}/downloadTermino`, {
         id_compania,
         id_seccion,
         id_empresa,
      });
      return data;
   } catch (error) {
      throw error;
   }
};

export const uploadTermino = async (_, formData) => {
   try {
      const { data } = await httpInstance.post(
         `${urlFiles}/uploadTermino`,
         formData,
      );
      return data;
   } catch (error) {
      throw error;
   }
};

export const getDescuentos = async ({ commit }) => {
   try {
      const { data } = await httpInstance.get(`${urlAbm}/descuentos`);
      commit('bsa/setDescuentos', data.descuentos, { root: true });
      commit('bsa/setGrupos', data.grupos, { root: true });
      commit('bsa/setEmpresas', data.empresas, { root: true });
      commit('bsa/setCompanias', data.companias, { root: true });

      return data;
   } catch (error) {
      throw error;
   }
};

export const getCompanias = async ({ commit }) => {
   try {
      const { data } = await httpInstance.get(`${urlAbm}/companias`);
      commit('bsa/setCompanias', data, { root: true });
   } catch (error) {
      throw error;
   }
};
export const getCoberturas = async ({ commit }, params = {}) => {
   try {
      const { data } = await httpInstance.get(`${urlAbm}/coberturas`, params);
      commit('bsa/setCoberturas', data.coberturas ?? data, { root: true });
      if (data.empresas) {
         commit('bsa/setEmpresas', data.empresas, { root: true });
      }
      if (data.companias) {
         commit('bsa/setCompanias', data.companias, { root: true });
      }
      if (data.secciones) {
         commit('bsa/setSecciones', data.secciones, { root: true });
      }
      if (data.empresaCompaniaSeccion) {
         commit('bsa/setEmpresaCompaniaSeccion', data.empresaCompaniaSeccion, {
            root: true,
         });
      }
      return Array.isArray(data.coberturas) ? data.coberturas : data;
   } catch (error) {
      throw error;
   }
};

export const createCobertura = async (_, payload) => {
   try {
      const { data } = await httpInstance.post(`${urlAbm}/cobertura`, payload);
      return data;
   } catch (error) {
      throw error;
   }
};

export const updateCobertura = async (_, payload) => {
   try {
      const { data } = await httpInstance.put(`${urlAbm}/cobertura`, payload);
      return data;
   } catch (error) {
      throw error;
   }
};

export const deleteCobertura = async (_, payload) => {
   try {
      await httpInstance.delete(`${urlAbm}/cobertura`, { data: payload });
   } catch (error) {
      throw error;
   }
};

export const updateCotizacion = async (_, cotizacion) => {
   try {
      const { data } = await httpInstance.put(
         `${urlBsa}/updateCotizacion`,
         cotizacion,
         true,
      );
      return data;
   } catch (error) {
      throw error;
   }
};

export const sendProspectosGPManual = async () => {
   try {
      const { data } = await httpInstance.post(`${urlBsa}/sendProspectosGP`);
      return data;
   } catch (error) {
      throw error;
   }
};

export const editarMasaSalarialYCapitas = async (_, data) => {
   try {
      const response = await httpInstance.put(
         `${urlFlujoArt}/masaSalarial`,
         data,
      );
      return response.data;
   } catch (error) {
      throw error;
   }
};

export const getComentario = async (_, seguimiento) => {
   try {
      const response = await httpInstance.get(`${urlBsa}/getComentario`, {
         id_seguimiento: seguimiento.id_seguimiento,
      });
      return response.data;
   } catch (error) {
      throw error;
   }
};

export const getEmpresasAll = async (_, params = {}) => {
   try {
      const query = {};
      if (params.q) {
         query.q = params.q;
      }
      const response = await httpInstance.get(`${urlEmpresa}/all`, query);
      return response.data;
   } catch (error) {
      throw error;
   }
};

export const getEmpresaCatalogos = async (_) => {
   try {
      const { data } = await httpInstance.get(`${urlEmpresa}/catalogos`);
      return data;
   } catch (error) {
      throw error;
   }
};

export const getEmpresaConfig = async (_, id_empresa) => {
   try {
      const { data } = await httpInstance.get(
         `${urlEmpresa}/${id_empresa}/config`,
      );
      return data;
   } catch (error) {
      throw error;
   }
};

export const createEmpresaAbm = async (_, payload) => {
   try {
      const { data } = await httpInstance.post(`${urlEmpresa}/create`, payload);
      return data;
   } catch (error) {
      throw error;
   }
};

export const updateEmpresaAbm = async (_, payload) => {
   try {
      const { data } = await httpInstance.put(`${urlEmpresa}/update`, payload);
      return data;
   } catch (error) {
      throw error;
   }
};

export const setEmpresaEstado = async (_, { id_empresa, estado }) => {
   try {
      const { data } = await httpInstance.put(
         `${urlEmpresa}/${id_empresa}/estado`,
         { estado },
      );
      return data;
   } catch (error) {
      throw error;
   }
};

export const uploadEmpresaIcon = async (_, { id_empresa, svgFile, pngFile }) => {
   try {
      const formData = new FormData();
      formData.append('svg', svgFile);
      formData.append('png', pngFile);
      const { data } = await httpInstance.post(
         `${urlEmpresa}/${id_empresa}/icon`,
         formData,
         true,
      );
      return data;
   } catch (error) {
      throw error;
   }
};

export const syncEmpresaSecciones = async (_, { id_empresa, id_secciones }) => {
   try {
      const { data } = await httpInstance.put(
         `${urlEmpresa}/${id_empresa}/secciones`,
         { id_secciones },
      );
      return data;
   } catch (error) {
      throw error;
   }
};

export const syncEmpresaCompanias = async (_, { id_empresa, relaciones }) => {
   try {
      const { data } = await httpInstance.put(
         `${urlEmpresa}/${id_empresa}/companias`,
         { relaciones },
      );
      return data;
   } catch (error) {
      throw error;
   }
};
